import img1 from "../src/images/software.jpg";
import img2 from "../src/images/andriod.jpeg";
import img3 from "../src/images/app.jpeg";
import img4 from "../src/images/web.png";
import img5 from "../src/images/markiting.jpeg";
import img6 from "../src/images/social.jpeg";
const Sdata = [
    {
       
        imgsrc:img1,
        title: "Software development",
        menu:"We offer full cycle web applicaction development services. we build apps that are secure and secure.",
    },
{
    
    imgsrc:img2,
    title: "Andriod development",
    menu: "Targeting Andriod with native, hybrid and cross platform development, ScienceSoft always gurantees sustainable and seamless mobile experience",
},

{
    
imgsrc: img3,
title: "App development",
menu: "We offer a full cycle of application design, integration and management services. Whether it is a consumer oriented app or a transformative enterprise class.",

},
{
    
    imgsrc: img4,
    title: "Web development",
    menu: "We help to Build a Clean, Creative and Professional Website Store to Connect to Your Buyers. Form Designing of your own choice",
},
{
    
    imgsrc:img5,
    title: "Digital Marketing",
    menu: "We Deliver Quality Creative Services and All Online Business Requirements to Our Clients. Build your Performance Marketing Strategy and increase Your ROI.",
},
{
    
    imgsrc: img6,
    title: "Social Marketing",
    menu: "We offer to utilize different social media platforms, such as Facebook, Twitter, Linkedin and What'sapp to establish brand recognition, capture customer attention",
},
]
export default Sdata;